import { NextSeo } from 'next-seo';
import { Fragment } from 'react';
import ReferralAbout from '../../components/promotion/referral/ReferralAbout';
import ReferralAccess from '../../components/promotion/referral/ReferralAccess';
import ReferralFAQ from '../../components/promotion/referral/ReferralFAQ';
import ReferralFooter from '../../components/promotion/referral/ReferralFooter';
import ReferralHeader from '../../components/promotion/referral/ReferralHeader';
import ReferralInstruction from '../../components/promotion/referral/ReferralInstruction';
import ReferralIntro from '../../components/promotion/referral/ReferralIntro';
import ReferralPreferences from '../../components/promotion/referral/ReferralPreferences';

const ReferralPage = () => {
  return (
    <Fragment>
      <NextSeo
        title="Приглашай друзей в агентство недвижимости «ЛЕНДЛОРД»"
        description="Информация об акции «Приглашай друзей» в агентстве недвижимости «ЛЕНДЛОРД» в Ростовской области"
        openGraph={{
          url: 'https://landlord.ru/promotion/referral',
          type: 'website',
          title: 'Приглашай друзей в агентство недвижимости «ЛЕНДЛОРД»',
          description:
            'Информация об акции «Приглашай друзей» в агентстве недвижимости «ЛЕНДЛОРД» в Ростовской области',
          images: [
            {
              url: '/images/og-preview.png'
            }
          ],
          site_name: 'LANDLORD'
        }}
      />
      <ReferralHeader />
      <main>
        <ReferralIntro />
        <ReferralAbout />
        <ReferralPreferences />
        <ReferralInstruction />
        <ReferralAccess />
        <ReferralFAQ />
      </main>
      <ReferralFooter />
    </Fragment>
  );
};

export default ReferralPage;
